import { NgModule } from '@angular/core';
import {MedicalToolSetModule} from "./toolset/medicalToolSet.module";
import {MedicalSterilizationSterilizationModule} from "./sterilization/medicalSterilization.module";

@NgModule({
  imports: [
    MedicalToolSetModule,
    MedicalSterilizationSterilizationModule,
  ]
})
export class MedicalSterilizationModule {
}

